@import (reference) '../../../constants/spacing.module.less';

/* https://zeroheight.com/2d379a49f/p/582195-layout/b/786f73 */
// min-widths
@extra-small-max-width: 320px;
@small-min-width: 744px;
@medium-min-width: 1024px;
@large-min-width: 1273px;
// max-widths
@extra-small-max-width: 743px;
@small-max-width: 1023px;
@medium-max-width: 1272px;

/* public media queries based on responsive layout breakpoints */
@extra-small-media-query: ~'only screen and (max-width: @{extra-small-max-width})';
@small-media-query: ~'only screen and (min-width: @{small-min-width}) and (max-width: @{small-max-width})';
@medium-media-query: ~'only screen and (min-width: @{medium-min-width}) and (max-width: @{medium-max-width})';

/* private container queries for this file */
@extra-small-container-query: ~'max-width: @{extra-small-max-width}';
@small-container-query: ~'@{small-min-width} <= width < @{small-max-width}';
@medium-container-query: ~'min-width: @{medium-max-width}';

.container {
  container: responsivelayout / inline-size;
  height: 100%;
  overflow-y: auto;
}

.grid {
  // All grid related variables have a `--layout--` prefix to avoid conflicts with other variables
  --layout--gap-width: @space-24;

  // The layout divides the container's width into 12 expandable sections separated by 13 fixed width gaps and sometimes a scrollbar
  // The amount of space not included in the 12 expandable sections are the 13 gaps and the scrollbar
  --layout--non-content-width: calc(var(--layout--scrollbar-width, 0px) + var(--layout--gap-width) * 13);
  // Each column has a width equal to the entire container's width minus the width of the gaps, all divided by 12
  --layout--col-width: calc((100cqw - var(--layout--non-content-width)) / 12);
  // An element that is full width has the width of the container's width minus the width of the left and right padding and the possible scrollbar
  --layout--full-width: calc(100cqw - (var(--layout--gap-width) * 2 + var(--layout--scrollbar-width, 0px)));

  // An element that should span X columns should have a width equal to the width of X columns plus the width of X-1 gaps in between those columns
  --layout--col-2: calc(var(--layout--col-width) * 2 + var(--layout--gap-width));
  --layout--col-3: calc(var(--layout--col-width) * 3 + var(--layout--gap-width) * 2);
  --layout--col-4: calc(var(--layout--col-width) * 4 + var(--layout--gap-width) * 3);
  --layout--col-6: calc(var(--layout--col-width) * 6 + var(--layout--gap-width) * 5);
  --layout--col-8: calc(var(--layout--col-width) * 8 + var(--layout--gap-width) * 7);
  --layout--col-9: calc(var(--layout--col-width) * 9 + var(--layout--gap-width) * 8);
  --layout--col-10: calc(var(--layout--col-width) * 10 + var(--layout--gap-width) * 9);
  --layout--col-12: var(--layout--full-width);

  max-width: @medium-max-width;

  padding: 0 var(--layout--gap-width) calc(var(--layout--gap-width) + var(--layout--scrollbar-width, 0px));
  gap: var(--layout--gap-width);
  overflow: hidden auto;

  @container responsivelayout (@extra-small-container-query) {
    // Below 743, the layout should be divided into 4 columns with 8px gaps
    --layout--gap-width: @space-8;

    // The 4 column layout divides a section's width into expandable sections separated by 5 gaps of a fixed width
    --layout--non-content-width: calc(var(--layout--scrollbar-width, 0px) + var(--layout--gap-width) * 5);

    // Each column has a width equal to the entire section's width minus the width of the gaps, all divided by 4
    --layout--col-width: calc((100cqw - var(--layout--non-content-width)) / 4);

    // To avoid needing/post-pone making distinct small widths/large widths for components, if an element is assigned a
    // responsive column width for the 12 column layout that is larger than the 4 column that is used in small containers,
    // we override the previous width calculations (which would be too large), and instead configure the full width.
    --layout--col-3: var(--layout--full-width);
    --layout--col-4: var(--layout--full-width);
    --layout--col-6: var(--layout--full-width);
    --layout--col-8: var(--layout--full-width);
    --layout--col-9: var(--layout--full-width);
    --layout--col-10: var(--layout--full-width);
  }

  @container responsivelayout (@small-container-query) {
    // Between 744 and 1023, the layout should be divided into 12 columns with 16px gaps
    --layout--gap-width: @space-16;
  }
  @container responsivelayout (@medium-container-query) {
    --layout--col-width: calc((@medium-max-width - var(--layout--non-content-width)) / 12);
    --layout--full-width: calc(@medium-max-width - var(--layout--gap-width) * 2);
  }
}

.responsive-gap {
  gap: var(--layout--gap-width);
}

.size2 {
  min-width: var(--layout--col-2);
  width: var(--layout--col-2);
}

.size3 {
  min-width: var(--layout--col-3);
  width: var(--layout--col-3);
}

.size4 {
  min-width: var(--layout--col-4);
  width: var(--layout--col-4);
}

.size6 {
  min-width: var(--layout--col-6);
  width: var(--layout--col-6);
}

.size8 {
  min-width: var(--layout--col-8);
  width: var(--layout--col-8);
}

.size9 {
  min-width: var(--layout--col-9);
  width: var(--layout--col-9);
}

.size10 {
  min-width: var(--layout--col-10);
  width: var(--layout--col-10);
}

.size12 {
  min-width: var(--layout--col-12);
  width: var(--layout--col-12);
}
